var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "50%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "py-0" },
            [
              _vm.area
                ? _c("v-textarea", {
                    attrs: { outlined: "", label: "Message" },
                    model: {
                      value: _vm.oldInfo,
                      callback: function ($$v) {
                        _vm.oldInfo = $$v
                      },
                      expression: "oldInfo",
                    },
                  })
                : _c("v-text-field", {
                    attrs: { outlined: "", label: "Message" },
                    model: {
                      value: _vm.oldInfo,
                      callback: function ($$v) {
                        _vm.oldInfo = $$v
                      },
                      expression: "oldInfo",
                    },
                  }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { color: "primary" },
                  on: { click: _vm.onPressSave },
                },
                [_vm._v("SAVE ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }